import { IController, ILocationService } from 'angular';
import * as _ from 'lodash';

import { SdcActionsService } from './../../../sdc/flux/sdc-actions.service';
import { ISdcStore } from './../../../sdc/flux/sdc-store.interface';
import { IFilter, TValidSdcViews } from './../../../sdc/sdc-state/sdc-state.typings';

interface IDropdownItem {
  humanName?: string;
  studentYear?: number;
}

export class ClassOfDropdownTransferCtrl implements IController {
  static inject: string[] = ['$scope', 'SDCStore', 'sdcActions', 'ObjectCache', '$location'];

  public cohortDropdown;
  public selectedCohort;
  public uiReady;
  public sdcView: TValidSdcViews = 'wizard';
  public allStudents;

  constructor(
    private $scope,
    private SDCStore: ISdcStore,
    private sdcActions: SdcActionsService,
    private ObjectCache,
    private $location: ILocationService,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.setUi();
        this.uiReady = true;
      }
    });
  }

  setUi() {
    this.allStudents = this.SDCStore.getAllFlattenedStudents();
    this.cohortDropdown = this.generateDropdown();
    const filter = this.SDCStore.getFilter();
    this.selectedCohort = this.initializeWithFilter(filter);
    this.filterSDCStudentsByCohort(this.selectedCohort);
  }

  filterSDCStudentsByCohort(cohort: IDropdownItem): void {
    let newFilter;
    const sdcView = this.sdcView;
    const sdcKey = this.SDCStore.getSdcKeyFromUiState();
    newFilter = cohort ? { cohort: [cohort] } : {};
    this.setFilterParam(newFilter);
    this.sdcActions.setEntireFilter({ newFilter, sdcKey, sdcView });
  }

  private generateDropdown(): IDropdownItem[] {
    const years = [];
    _.each(this.allStudents, ({ cohort }: any) => {
      if (!_.includes(years, cohort)) years.push(cohort);
    });
    return _.sortBy(years);
  }

  private initializeWithFilter(filter) {
    let cohortFilter = filter.cohort;
    if (!cohortFilter || cohortFilter.length > 1) {
      cohortFilter = {};
      this.setFilterParam(cohortFilter);
      return null; // shows `All` option
    } else {
      cohortFilter = _.head(cohortFilter);
      this.setFilterParam(cohortFilter);
      return cohortFilter; // shows specific cohort
    }
  }

  private setFilterParam(filter: IFilter): void {
    const filterHash = this.ObjectCache.cacheObject(filter);
    this.$location.search('filter', filterHash).replace();
  }
}
